import ReactDOM from 'react-dom'
import { StrictMode } from 'react'
import App from './App'
import { UserProvider, AuthProvider, GeneralProvider } from './context'

ReactDOM.render(
  <StrictMode>
    <GeneralProvider>
      <AuthProvider>
        <UserProvider>
          <App />
        </UserProvider>
      </AuthProvider>
    </GeneralProvider>
  </StrictMode>,
  document.getElementById('root')
)
